import React, { memo } from 'react';
import { useHitTracking } from '../../../context/hit-tracking-context';
import '../../selections/selections.scss'

const areTitlesEqual = (prevTitles = [], nextTitles = []) => {
    if (prevTitles === nextTitles) return true;
    if (prevTitles.length !== nextTitles.length) return false;

    for (let i = 0; i < prevTitles.length; i++) {
        const prev = prevTitles[i];
        const next = nextTitles[i];
        if (!prev || !next) return false;
        if (prev.id !== next.id || prev.name !== next.name) {
            return false;
        }
    }

    return true;
};

const ParallelButtonSelection = memo(({ titles = [], activeTitle, clickTitle }) => {
    const { trackInteraction } = useHitTracking();

    const handleClick = (title) => {
        const categoryName = title.binding || title.code || title.name || title.id;

        if (activeTitle !== title.id && categoryName) {
            trackInteraction(categoryName);
        }

        clickTitle?.(title);
    };

    return (
        <div className='parallel-button-selection'>
            <div className='options-row'>
                {titles.map((title, index) =>
                    <div
                        key={title.id}
                        className={`roboto-medium-14 ${activeTitle === title.id ? 'active' : ''} ${index === 0 ? 'paralel-button-first' : 'paralel-button'}`}
                        onClick={() => handleClick(title)}>
                        <span className={index === 0 ? '' : 'skew-fix title'} >
                            {title.name}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}, (prevProps, nextProps) => {
    return prevProps.activeTitle === nextProps.activeTitle
        && prevProps.clickTitle === nextProps.clickTitle
        && areTitlesEqual(prevProps.titles, nextProps.titles);
});

// Add display name for debugging
ParallelButtonSelection.displayName = 'ParallelButtonSelection';

export default ParallelButtonSelection;
